var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isProjectOverview)?_c('file-browser-height',{staticClass:"repository-tree-list gl-mt-5",style:({ width: `${_vm.treeWidth}px` })},[_c('tree-list',{staticClass:"gl-mr-5",attrs:{"project-path":_vm.projectPath,"current-ref":_vm.currentRef,"ref-type":_vm.refType}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }